import { atom } from "recoil";

import {
  User,
  Columns,
  Filters,
  TableParams,
  Sorting,
  Mode,
} from "../types/index";
export const appVersion = "1.4.0";

const defaultFilterParams: Filters = {
  salesNo: "", // 空文字列で初期化
  productNo: "", // 空文字列で初期化
  factory: [50], // 空の配列で初期化
  situation: [0], // 空の配列で初期化
  dateField: "完成予定",
  fromDate: "",
  toDate: "",
};
const defaultTableParams: TableParams = {
  selectedPage: 1,
  junmpPage: "1",
  selectedDisplayNumber: 20,
  keywords: "",
  sorting: Array<Sorting>(),
  columnFilters: [],
};

const loginUser: User = {
  appVersion: appVersion,
  workerId: 0, // 社員番号は未使用なので0としますが、必要に応じてnullや適切なデフォルト値に変更してください。
  mail: "", // 空文字で初期化
  photoURL: "", // 空文字で初期化
  workerName: "", // 社員名を空文字で初期化
  viewId: 0, // ビューを選択する
  isAuth: false, // 認証状態をfalseで初期化
  mode: "lite",
  // mode: "dark",
  columnsAllFactory: Array<Columns>(), // カラム情報を空配列で初期化
  columnsPT: Array<Columns>(), // カラム情報を空配列で初期化
  columnsPV: Array<Columns>(), // カラム情報を空配列で初期化
  columnsKanto: Array<Columns>(), // カラム情報を空配列で初期化
  columnsFukuokaKumamoto: Array<Columns>(), // カラム情報を空配列で初期化
  columnsSite: Array<Columns>(),
  filters: defaultFilterParams, // フィルタ情報を空配列で初期化
  tableParams: defaultTableParams,
};

const initializeUserFromLocalStrate = () => {
  const storedUser = localStorage.getItem("LoginUserOnEndMaRK");
  if (storedUser) {
    try {
      const userObject = JSON.parse(storedUser);
      // console.log("userObject", userObject, appVersion, userObject.appVersion);
      if (userObject.appVersion !== appVersion) {
        localStorage.clear();
        return loginUser;
      }
      return userObject;
    } catch (error) {
      console.error("Parsing error", error);
      return loginUser; // パースに失敗した場合のデフォルト値
    }
  } else {
    return loginUser; // LocalStorageにデータがない場合のデフォルト値
  }
};
export const userState = atom({
  key: "userState",
  default: initializeUserFromLocalStrate(),
});
